import { Check } from '@octopus-do/octopus-storybook/icons'
import { migrationUiSelector } from '@store/migrationSelectors/uiSelectors'
import type { AppState } from '@store/types'
import type React from 'react'
import { useSelector } from 'react-redux'

import { Spinner } from '@/lib/components'
import type { SyncStatus } from '@/types'
import { clsJoin } from '@/utils'
import css from './styles.module.css'

export const SyncStatusIndicator: React.FC = () => {
  const syncStatus = useSelector<AppState, SyncStatus>(
    migrationUiSelector.getSyncStatus
  )

  return (
    <div className={clsJoin(css.indicator_wrap, css[syncStatus])}>
      <div className={css.indicator_content}>
        <Check className={clsJoin(css.icon, css[syncStatus])} />
        <div className={clsJoin(css.spinner_wrap, css[syncStatus])}>
          <Spinner />
        </div>
      </div>
    </div>
  )
}
